import './Installation.scss'

const { Link } = require('@paymongo/seeds');

const Installation = () => {
  const dashboardUrl: string = `${process.env.REACT_APP_DASHBOARD_URL}/developers`;

  return (
    <div className="installation">
      <p className="text">
        Thank you for installing PayMongo for Shopify!
        <br />
        To be able to use the payment methods, you need to connect your Paymongo account <br/>
        to your Shopify account.
      </p>

      <p>
        We will verify your account by connecting your PayMongo to your Shopify.
        <br />
        <Link href={dashboardUrl} target="_blank"> Click here </Link> to get your Live API keys
        &nbsp;<span className="-shade800">(You must be logged in the PayMongo Dashboard)</span>.
      </p>

      <h2 className="-brand600"><strong>Connect your PayMongo account</strong></h2>
    </div>
  );
}

export default Installation;
